import { Injectable } from '@angular/core';

@Injectable({
	providedIn: 'root',
})
export class NumbersService {
	constructor() {}

	format(value: string): string {
		return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
	}

	toNumeric(number: any) {
		return number.replace(new RegExp('[\u0660-\u0669\u06f0-\u06f9]', 'g'), (c) => {
			return c.charCodeAt(0) & 0xf;
		});
	}

	/**
	 * Prevent to input number or digit
	 */
	allowNumberOnly($event) {
		let value = $event.target.value;
		const initalValue = value;
		value = initalValue.replace(/[^0-9\.]*/g, '');
		if (initalValue !== value) {
			return $event.stopPropagation();
		}
	}
}
